import { observable, action } from 'mobx';
import { AxiosInstance } from 'axios';
import type { IUserProfileModel } from 'interfaces/user/IUserProfileModel';
import { Result } from 'services/Result';
import { container } from 'services/ioc/ioc';
import { ServiceTypes } from '../constants/ServiceTypes';

class ProfileStore {
  @observable userId = '';

  @observable firstName = '';

  @observable lastName = '';

  @observable fullName = '';

  @observable email = '';

  @observable photoUrl: string | null = null;

  @observable isLoggingOut = false;

  @observable authority = '';

  @observable preferredLanguage: string | null = null;

  @observable preferredUnitSystem: string | null = null;

  @observable public loaded = false;

  @action setLogoutAction(value: boolean) {
    this.isLoggingOut = value;
  }

  @action setUserData(data: IUserProfileModel) {
    this.userId = data.userId;
    this.email = data.email;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.photoUrl = data.profilePhotoUrl;
    this.preferredLanguage = data.preferredLanguage;
    this.preferredUnitSystem = data.preferredUnitSystem || 'imperial';
    this.authority = data.authority;

    if (!this.firstName && !this.lastName) {
      this.fullName = '';
    } else {
      this.fullName = (data.firstName == null ? '' : `${data.firstName} `) + (data.lastName || '');
    }
    this.loaded = true;
  }

  @action setUnknownUser() {
    this.loaded = false;
    this.fullName = 'Unknown user';
  }

  @action public async ensureDataAvailability() {
    if (this.loaded) {
      return;
    }
    await this.LoadData();
  }

  private async LoadData() {
    const api = container.get<AxiosInstance>(ServiceTypes.ApiService);
    const response = await api.get<Result<IUserProfileModel>>('account/profile');
    if (response && response.data && !response.data.isError && response.data.data) {
      this.setUserData(response.data.data);
    } else {
      this.setUnknownUser();
    }
  }
}

export const profile = new ProfileStore();
